export const StepModeValue = {
  SelectBoard: 'select-board',
  Upload: 'upload',
  Crop: 'crop',
  ChooseVariant: 'choose-variant',
  ShowReadyArt: 'show-ready-art',
  EnterEmail: 'enter-email',
  ConfirmEmail: 'confirm-email',
  FinishSelect: 'finish-select',
  Builder: 'builder',
};

const {
  Builder,
  ConfirmEmail,
  EnterEmail,
  FinishSelect,
  SelectBoard,
  ShowReadyArt,
  Upload,
  Crop,
  ChooseVariant,
} = StepModeValue;

export type StepMode =
  | typeof SelectBoard
  | typeof Upload
  | typeof ShowReadyArt
  | typeof EnterEmail
  | typeof ConfirmEmail
  | typeof FinishSelect
  | typeof Builder
  | typeof Crop
  | typeof ChooseVariant;
